import darkTheme from "./darkTheme";
import lightGreyTheme from "./lightGreyTheme";
import lightTheme from "./lightTheme";
export default class Themes {
}
Themes.light = lightTheme;
Themes.dark = darkTheme;
Themes.lightGrey = lightGreyTheme;
Themes.default = Themes.light;
